<template>
  <div>
    <el-row v-if="componentShow === 'groupBuyProductManage'">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <div class="card-body">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-input
                  v-model="conditions.prodName"
                  placeholder="请输入商品名称"
                  clearable
                />
              </el-col>
              <el-col :span="8">
                <el-input
                  v-model="conditions.keyword"
                  placeholder="请输入关键字"
                  clearable
                />
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="conditions.barCode"
                  placeholder="请输入产品条码"
                  clearable
                />
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="queryProductMethod">
                  <i class="el-icon-search"></i> 查询
                </el-button>
                <el-button @click="resetProductMethod">
                  <i class="el-icon-refresh"></i> 重置
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row v-if="componentShow === 'groupBuyProductManage'">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>拼团商品</span>
            <div style="float: right;">
              <el-button type="primary" size="small" @click="openAddProductModal">
                <i class="el-icon-plus"></i>添加
              </el-button>
            </div>
          </div>
          <div class="card-body">
            <el-table
              :data="products"
              border
              style="width: 100%"
            >
              <el-table-column prop="batchId" label="当前批次" align="center" />
              <el-table-column prop="productId" label="商品ID" align="center" />
              <el-table-column label="商品图片" align="center">
                <template slot-scope="scope">
                  <el-image
                    style="width: 60px; height: 60px; border-radius: 5px;"
                    :src="scope.row.coverPhoto"
                    fit="cover"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="groupProdName" label="拼团名称" align="center" />
              <el-table-column prop="userCount" label="拼团人数" align="center" />
              <el-table-column prop="stock" label="库存" align="center" />
              <el-table-column prop="groupBuyCount" label="参与人数" align="center" />
              <el-table-column prop="sort" label="排序" align="center" />
              <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                  {{ scope.row.state === '1001' ? '开启' : '关闭' }}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="openEditProductModel(scope.row)"
                  >修改</el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click="openDeleteProductModel(scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total"
              style="margin-top: 20px; text-align: right;"
            />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-group-buy-product
      v-if="componentShow === 'addGroupBuyProduct'"
      ref="addGroupBuyProduct"
      @close="handleCloseAddProduct"
    />
    
    <edit-group-buy-product
      v-if="componentShow === 'editGroupBuyProduct'"
      ref="editGroupBuyProduct"
      :product-data="currentProduct"
      @close="handleCloseEditProduct"
    />
    
    <delete-group-buy-product
      ref="deleteGroupBuyProduct"
      @close="handleCloseDeleteProduct"
    />
  </div>
</template>

<script>
import { getGroupBuyProductList } from '@/api/goods/groupBuyProductApi'
import AddGroupBuyProduct from '@/components/goods/addGroupBuyProduct/addGroupBuyProduct'
import EditGroupBuyProduct from '@/components/goods/editGroupBuyProduct/editGroupBuyProduct'
import DeleteGroupBuyProduct from '@/components/goods/deleteGroupBuyProduct/deleteGroupBuyProduct'

export default {
  name: 'GroupBuyProductManage',
  components: {
    AddGroupBuyProduct,
    EditGroupBuyProduct,
    DeleteGroupBuyProduct
  },
  data() {
    return {
      componentShow: 'groupBuyProductManage',
      products: [],
      conditions: {
        prodName: '',
        keyword: '',
        barCode: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentProduct: null
    }
  },
  created() {
    this.getProductList()
  },
  methods: {
    async getProductList() {
      try {
        const params = {
          ...this.conditions,
          page: this.currentPage,
          row: this.pageSize
        }
        const res = await getGroupBuyProductList(params)
        this.products = res.data
        this.total = res.total
      } catch (error) {
        console.error('获取拼团商品列表失败:', error)
      }
    },
    queryProductMethod() {
      this.currentPage = 1
      this.getProductList()
    },
    resetProductMethod() {
      this.conditions = {
        prodName: '',
        keyword: '',
        barCode: ''
      }
      this.currentPage = 1
      this.getProductList()
    },
    openAddProductModal() {
      this.componentShow = 'addGroupBuyProduct'
    },
    openEditProductModel(product) {
      this.currentProduct = product
      this.componentShow = 'editGroupBuyProduct'
      this.$nextTick(() => {
        this.$refs.editGroupBuyProduct.open(product)
      })
    },
    openDeleteProductModel(product) {
      this.$refs.deleteGroupBuyProduct.open(product)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getProductList()
    },
    handleCloseAddProduct() {
      this.componentShow = 'groupBuyProductManage'
      this.getProductList()
    },
    handleCloseEditProduct() {
      this.componentShow = 'groupBuyProductManage'
      this.getProductList()
    },
    handleCloseDeleteProduct() {
      this.getProductList()
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}
</style>